var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3862 6.40698C27.9404 6.07446 28.6328 6.07446 29.187 6.40698L52.5203 20.407C53.1948 20.8117 53.5164 21.6167 53.3064 22.3747C53.0965 23.1328 52.4065 23.6576 51.6199 23.6576H4.95328C4.16669 23.6576 3.47674 23.1328 3.26678 22.3747C3.05681 21.6167 3.37841 20.8117 4.05291 20.407L27.3862 6.40698ZM11.2713 20.1576H45.3019L28.2866 9.94843L11.2713 20.1576Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20312 49.9076C3.20312 48.9411 3.98663 48.1576 4.95313 48.1576H51.6198C52.5863 48.1576 53.3698 48.9411 53.3698 49.9076C53.3698 50.8741 52.5863 51.6576 51.6198 51.6576H4.95313C3.98663 51.6576 3.20312 50.8741 3.20312 49.9076Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7865 20.1576C11.753 20.1576 12.5365 20.9411 12.5365 21.9076V49.9076C12.5365 50.8741 11.753 51.6576 10.7865 51.6576C9.81996 51.6576 9.03646 50.8741 9.03646 49.9076V21.9076C9.03646 20.9411 9.81996 20.1576 10.7865 20.1576Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4531 20.1576C23.4196 20.1576 24.2031 20.9411 24.2031 21.9076V49.9076C24.2031 50.8741 23.4196 51.6576 22.4531 51.6576C21.4866 51.6576 20.7031 50.8741 20.7031 49.9076V21.9076C20.7031 20.9411 21.4866 20.1576 22.4531 20.1576Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1198 20.1576C35.0863 20.1576 35.8698 20.9411 35.8698 21.9076V49.9076C35.8698 50.8741 35.0863 51.6576 34.1198 51.6576C33.1533 51.6576 32.3698 50.8741 32.3698 49.9076V21.9076C32.3698 20.9411 33.1533 20.1576 34.1198 20.1576Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7865 20.1576C46.753 20.1576 47.5365 20.9411 47.5365 21.9076V49.9076C47.5365 50.8741 46.753 51.6576 45.7865 51.6576C44.82 51.6576 44.0365 50.8741 44.0365 49.9076V21.9076C44.0365 20.9411 44.82 20.1576 45.7865 20.1576Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.8073e9e9.svg";
export { ForwardRef as ReactComponent };